import { useSessionStorage } from "@uidotdev/usehooks";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import { IFilterPickup } from "../../types/interface";
import { hasValues } from "../../utils/hasValues";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import PickupRequestFilter from "./PickupRequestFilter";
import { tw } from "@careinfo/tailwind";
import Modal from "../Reusable/Modal";
import { Remark } from "@careinfo/layout";
import CommentIcon from "../../Icons/CommentIcon";
import { AccessControl } from "@careinfo/permission-required";

const PickupRequestList = () => {
  const navigate = useNavigate();
  const [localState, handleSetState] = useSessionStorage<IFilterPickup>(
    "pickup-request",
    {
      created__range: null,
      vehicle: null,
      driver: null,
      merchant: null,
    }
  );
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [receiver, setReceiver] = useState("");


  const handleRecevierName = (row: any) => {
    setReceiver(row);
  };


  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const { setValue, getValues, watch, reset, control } = useForm<IFilterPickup>(
    {
      defaultValues: async () => ({
        created__range: localState?.created__range ?? null,
        vehicle: localState?.vehicle ?? null,
        driver: localState?.driver ?? null,
        merchant: localState?.merchant ?? null,
      }),
    }
  );
  const handleFilterReset = () => {
    reset({
      created__range: null,
      vehicle: null,
      driver: null,
      merchant: null,
    });
  };
  const defaultColumns: any = [
    {
      header: "Pickup ID",
      accessorKey: "serial_number",
      cell: NACell,
    },
    {
        header: "",
        accessorKey: "remark",
        // cell: ({ row, getValue }: any) => (
        //   <button
        //     onClick={(e) => {
        //       e.stopPropagation();
        //       setSelectedOrder(row?.original?.id);
        //       setOpenReviewModal(true);
        //     }}
        //   >
        //     <CommentIcon/>{getValue()} 
        //   </button>
        // ),
        cell: ({ row, getValue }: any) => (
        <>
          <AccessControl
            children={
              <button
                className={tw`focus:outline-none opacity-0 group-hover:opacity-100 transition-opacity duration-200 w-fit`}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedOrder(row?.original?.id);
                  setOpenReviewModal(true);

                  handleRecevierName(row?.original?.receiver);
                }}
              >
                 <div className={tw`relative`}>
                  <CommentIcon className={tw`text-black-500 w-6 h-6`}/>
                  <p className={tw`absolute -right-1 -top-1 text-xs text-blue-500`}>{getValue()}</p>
                  </div>
              </button>
            }
            allowedPermissions={["can_view_remarks"]}
            renderNoAccess={<p>{getValue()} Remarks</p>}
          />
        </>
      ),
      },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ getValue }: any) => {
        return (
          <>
            <p className={tw`w-[100px]`}>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Sender",
      accessorKey: "sender_name",
      cell: ({ row, getValue }: any) => (
        <div>
          <p>{getValue()}</p>
          <p className={tw`text-xs`}>Address:{row?.original?.sender_address}</p>
          <p className={tw`text-xs`}>
            Contact:{row?.original?.sender_primary_contact}
          </p>
        </div>
      ),
    },
    {
      header: "Receiver",
      accessorKey: "receiver_name",
      cell: ({ row, getValue }: any) => (
        <div>
          <p>{getValue() ?? "N/A"}</p>
          <p className={tw`text-xs`}>
            Address:{row?.original?.receiver_address}
          </p>
          <p className={tw`text-xs`}>
            Contact:{row?.original?.receiver_primary_contact}
          </p>
        </div>
      ),
    },
    {
      header: "Driver",
      accessorKey: "driver.user.full_name",
      cell: NACell,
    },
    {
      header: "Priority",
      accessorKey: "priority",
      cell: NACell,
    },
    {
      header: "Total Box",
      accessorKey: "order_count",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0}</p>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0}</p>
          </>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "is_received",
      cell: ({ getValue }: any) => {
        return (
          <>
            {getValue() ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18457 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86M22 4L12 14.01L9.00001 11.01"
                  stroke="#26C943"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                  stroke="red"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
          </>
        );
      },
    },
    // {
    //   header: "Received Items",
    //   accessorKey: "items.received",
    //   cell: ({ getValue }: any) => {
    //     return (
    //       <>
    //         <p>{getValue() ?? 0.0}</p>
    //       </>
    //     );
    //   },
    // },
    // {
    //   header: "Missing Items",
    //   accessorKey: "items.missing",
    //   cell: ({ getValue }: any) => {
    //     return (
    //       <>
    //         <p>{getValue() ?? 0.0}</p>
    //       </>
    //     );
    //   },
    // },
  ];
  const handleEditNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };

  const filterParams = watch();

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]);

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <PickupRequestFilter
          isFilterVisible={isFilterVisible}
          setValue={setValue}
          getValues={getValues}
          handleFilterReset={handleFilterReset}
          control={control}
        />
      </Card>
      <DataTable
        url={`${APIS.PICKUPREQUEST}`}
        queryKey={"pickup-request"}
        handleEditNavigate={handleEditNavigate}
        columns={defaultColumns}
        orderSearch={true}
        tableName={"pickup-request-list"}
        addNewPagePath={"create"}
        params={{ ...params(), ordering: "is_received,-created" }}
      />
      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
      >
        <div className={tw`w-[600px]`}>
          <Remark selectedOrder={selectedOrder} receiver={receiver} />
        </div>
      </Modal>
    </>
  );
};

export default PickupRequestList;
